var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "history-area", attrs: { "data-app": "" } },
    [
      _c(
        "div",
        { staticClass: "management-section-wrapper" },
        [
          _c("v-data-table", {
            attrs: {
              headers: _vm.headers,
              items: _vm.reports,
              loading: _vm.loading,
              "loading-text": "",
              page: _vm.pagination.page,
              "items-per-page": _vm.paginationHistoryArea.rowsPerPage,
              "items-per-page-text": _vm.rowsPerPageText,
              "items-per-page-items": _vm.rowsPerPageItems,
              "header-props": { sortIcon: _vm.sortIcon },
              "footer-props": {
                prevIcon: _vm.prevIcon,
                nextIcon: _vm.nextIcon,
                "items-per-page-options": _vm.rowsPerPageItems
              }
            },
            on: {
              "update:page": function($event) {
                return _vm.$set(_vm.pagination, "page", $event)
              },
              "update:itemsPerPage": function($event) {
                return _vm.$set(
                  _vm.paginationHistoryArea,
                  "rowsPerPage",
                  $event
                )
              },
              "update:items-per-page": function($event) {
                return _vm.$set(
                  _vm.paginationHistoryArea,
                  "rowsPerPage",
                  $event
                )
              },
              pagination: function($event) {
                return _vm.setRowsOnLocalStorage(
                  _vm.dataTableHistoryAreaId,
                  _vm.paginationHistoryArea.rowsPerPage
                )
              }
            },
            scopedSlots: _vm._u([
              {
                key: "item",
                fn: function(props) {
                  return [
                    _c("tr", [
                      _c("td", [
                        _vm._v(
                          "\n            " +
                            _vm._s(
                              props.item && props.item.finalized_at
                                ? props.item.finalized_at
                                : props.item.created_at
                            ) +
                            "\n          "
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(
                          _vm._s(_vm.getWorkspaceName(props.item.workspace_id))
                        )
                      ]),
                      _vm._v(" "),
                      _c("td", [
                        _vm._v(_vm._s(_vm.getReportTypeLabel(props.item)))
                      ]),
                      _vm._v(" "),
                      _c(
                        "td",
                        { staticStyle: { "text-transform": "uppercase" } },
                        [
                          _vm._v(
                            "\n            " +
                              _vm._s(_vm.getStepAndStatus(props.item)) +
                              "\n          "
                          )
                        ]
                      ),
                      _vm._v(" "),
                      _c(
                        "td",
                        [
                          _c(
                            "v-layout",
                            {
                              attrs: {
                                row: "",
                                "justify-end": "",
                                "align-center": ""
                              }
                            },
                            [
                              _vm.isSuccessful(props.item)
                                ? _c("management-table-button", {
                                    staticStyle: {
                                      height: "25px",
                                      "min-width": "unset",
                                      padding: "6px 6px 6px 8px",
                                      "margin-right": "35px"
                                    },
                                    attrs: {
                                      "button-type": "Download",
                                      "file-url": props.item.file_url_public,
                                      "without-label": true,
                                      disabled: !_vm.userHasManagementPermission(
                                        "export_show"
                                      )
                                    },
                                    on: {
                                      buttonClick: function($event) {
                                        return _vm.downloadExport(
                                          props.item.file_url_public,
                                          $event
                                        )
                                      }
                                    }
                                  })
                                : _vm._e(),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                { attrs: { shrink: "" } },
                                [
                                  _vm.isDeletable(props.item)
                                    ? _c("app-datatable-action-buttons", {
                                        staticStyle: {
                                          "padding-right": "10px"
                                        },
                                        attrs: {
                                          "user-can-edit": false,
                                          "user-can-delete": true,
                                          "visibility-hover": false
                                        },
                                        on: {
                                          delete: function($event) {
                                            return _vm.askConfirmationToDeleteItem(
                                              props.item
                                            )
                                          }
                                        }
                                      })
                                    : _vm._e()
                                ],
                                1
                              ),
                              _vm._v(" "),
                              !_vm.isDeletable(props.item)
                                ? _c(
                                    "v-btn",
                                    {
                                      attrs: {
                                        "x-small": "",
                                        text: "",
                                        color: "accent"
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.cancelExport(props.item)
                                        }
                                      }
                                    },
                                    [
                                      _c(
                                        "span",
                                        {
                                          staticStyle: { "font-size": "10px" }
                                        },
                                        [_vm._v(_vm._s(_vm.$t("Cancel")))]
                                      )
                                    ]
                                  )
                                : _vm._e(),
                              _vm._v(" "),
                              !_vm.isDeletable(props.item)
                                ? _c("v-progress-circular", {
                                    staticClass: "mx-3",
                                    attrs: {
                                      indeterminate: "",
                                      size: "20",
                                      width: "3",
                                      color: "accent"
                                    }
                                  })
                                : _vm._e()
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ])
                  ]
                }
              },
              {
                key: "item.include_buildings",
                fn: function(ref) {
                  var item = ref.item
                  return [
                    _c("v-checkbox", {
                      attrs: { disabled: "" },
                      model: {
                        value: item.include_buildings,
                        callback: function($$v) {
                          _vm.$set(item, "include_buildings", $$v)
                        },
                        expression: "item.include_buildings"
                      }
                    })
                  ]
                }
              },
              {
                key: "no-data",
                fn: function() {
                  return [
                    _vm.loading
                      ? _c("div", { staticStyle: { width: "100%" } })
                      : _c(
                          "v-alert",
                          {
                            staticClass: "data-table-no-data",
                            attrs: { icon: "warning" }
                          },
                          [
                            _vm._v(
                              "\n          " +
                                _vm._s(_vm.$t("NoDataExport")) +
                                "\n        "
                            )
                          ]
                        )
                  ]
                },
                proxy: true
              }
            ])
          })
        ],
        1
      ),
      _vm._v(" "),
      _c("app-dialog-box", {
        attrs: {
          open: _vm.deleteDialog,
          title: _vm.$t("DeleteReport"),
          content:
            _vm.$t("DeleteConfirmation") +
            " " +
            _vm.$tc("ExportNoun", 1) +
            " " +
            _vm.itemToDelete.id +
            "?",
          "main-action-label": _vm.$t("No"),
          "secondary-action-label": _vm.$t("Yes")
        },
        on: { mainAction: _vm.cancelDelete, secondaryAction: _vm.deleteExport }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-10d31f4b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-10d31f4b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Home/Content/Tabs/Reports/History/HistoryArea.vue
// module id = null
// module chunks = 